const fontFamily = {
    main: 'Roboto',
    code: 'Roboto Mono',
};
const fontWeight = {
    400: 400,
    500: 500,
    700: 700,
};
const fontSize = {
    xxs: '10px',
    xs: '11px',
    sm: '12px',
    md: '14px',
    lg: '16px',
    xl: '18px',
    xxl: '20px',
    displayXS: '24px',
    displayS: '32px',
    displayM: '40px',
};
const lineHeight = {
    xxs: '10px',
    xs: '12px',
    sCompact: '16px',
    sDefault: '18px',
    mDefault: '20px',
    mRoomy: '24px',
    lg: '24px',
    xl: '26px',
    xxl: '28px',
    displayXS: '38px',
    displayM: '48px',
};
export const font = {
    family: fontFamily,
    weight: fontWeight,
    size: fontSize,
    lineHeight,
};
//# sourceMappingURL=font.js.map